module.exports = __webpack_public_path__ + "media/images/team/default-female-7859cfe4ef36fe452d8c8c6dfcd3b13b.png";